import { Record } from 'immutable';
import * as A from './actions';
import { NotificationsFactory } from './adapters';

const initialState = new Record({
  isLoading: false,
  data: NotificationsFactory(),
});

export const reducer = {
  notifications(state = initialState(), action) {
    switch (action.type) {
      case A.getNotificationsAction.request:
        return state.setIn(['isLoading'], true);

      case A.getNotificationsAction.success:
        return state.setIn(['data'], action.payload).setIn(['isLoading'], false);
      case A.getNotificationsAction.failure:
        return state.setIn(['isLoading'], false);

      // UPDATE
      case A.updateNotificationsAction.success:
        return state.setIn(['data'], action.payload);

      default:
        return state;
    }
  },
};
